import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex items-end gap-4 mb-4" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "bank-name",
  class: "label-text"
}, "Pilih Bus", -1)
const _hoisted_5 = { class: "invalid-feedback" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "mb-3 rounded-lg border-grey-alt p-3" }
const _hoisted_8 = { class: "text-sm font-bold required" }
const _hoisted_9 = { class: "flex items-center gap-4" }
const _hoisted_10 = { class: "w-1/2" }
const _hoisted_11 = ["for"]
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = { class: "w-1/2" }
const _hoisted_14 = ["for"]
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "container-btn-action" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import { Form, Field, FieldArray, ErrorMessage } from 'vee-validate'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, ref, reactive, getCurrentInstance, computed } from 'vue'
import type { Ref } from 'vue'
import IResponse from '@/utils/interfaces/iResponse'
import apiUseCase from '@/usecase/apiUseCase'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import HjpCofirmModal from '@/views/components/modal/HjpConfirmationModal.vue'
import Calendar from 'primevue/calendar'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'EditSlot',
  emits: ["hideDialog"],
  setup(__props, { emit }: { emit: ({
  (event: 'hideDialog', state: any): void
}), expose: any, slots: any, attrs: any }) {

const moduleStore = 'hjpTable'
const endpointTrayek = '/management/v1/Trayek'
const endpointTrayekDetail = '/management/v1/TrayekDetail'



const store = useStore()
const app = getCurrentInstance()
const {
  $toast
} = app!.appContext.config.globalProperties
const dataOptionBank = ref([]) as any
const dataForm = ref()
const isUpdate = ref(false)
const titleButton = ref('Simpan ID Credential Bank')
const idPrams = computed(() => store.state[moduleStore].modal?.data?.Id)
const idDetailParams = computed(() => store.state[moduleStore].modal?.data?.DetailId)
const idTrayekParams = computed(() => store.state[moduleStore].modal?.data?.TrayekId)

const initialValues = reactive({
  vehicle: null as any,
  pps: [] as any
})

const schema = Yup.object().shape({
  pps: Yup.array().of(
    Yup.object().shape({
      pp1: Yup.string().when(['pp2'], ([pp2], sch) => (pp2 && pp2.length > 0 ? sch.required('Jam Berangkat tidak boleh kosong') : sch.notRequired())),
      pp2: Yup.string().when(['pp1'], ([pp1], sch) => (pp1 && pp1.length > 0 ? sch.required('Jam Kedatangan tidak boleh kosong') : sch.notRequired()))
    }, [['pp1', 'pp2'], ['pp2', 'pp1']])
  ).test('is-unique', 'Jam Keberangkatan tidak boleh ada yang sama', (val) => {
    // console.log('val', val)
    if (!Array.isArray(val)) {
      return true
    }
    const set = new Set()
    // console.log('set', set)
    for (let i = 0; i < val.length; i++) {
      if (val[i]) {
        // console.log(val[i])
        const temp: any = val[i]
        // console.log('xxx', temp.pp1)
        // console.log('val', val[i])
        // console.log('aaaa', [i, val[i], set, set.has(temp.Id)])
        if (set.has(temp.pp1) && temp.pp1) {
          // console.log('exist')
          return false
        }
        set.add(temp.pp1)
      }
    }
    return true
  })
})

const isLoading = ref(true)

// const initialValues = ref({})

const attrModalConfirmation = reactive({
  show: false,
  title: 'Apakah Anda Yakin Ingin Menyimpan Trayek Slot Ini ?',
  subTitle: 'Pastikan data yang Anda masukkan sudah benar sebelum tersimpan',
  btnSubmitTitle: 'Simpan',
  imgContent: require('@/assets/img/modal-confirmation/roster-confirmation.svg')
})

const onSubmit = (values: any) => {
  console.log('values', values)
  dataForm.value = values
  // const channels = values.channels.map((x: any) => ({
  //   OaAccount: x.channel_id
  // }))
  // store.dispatch('showLoading')
  // dataForm.value = {
  //   IdCorporate: values.corporateId,
  //   MsBankId: values.bankName.value,
  //   Description: values.description,
  //   IsActive: values.isActive,
  //   IsDelete: false,
  //   ChannelBank: channels
  // }
  attrModalConfirmation.show = true
  // console.log('dataform', dataForm)
  // store.dispatch('hideLoading')
}

const onSubmitConfirmation = async () => {
  store.dispatch('showLoading')
  const payload = {
    id: idDetailParams.value,
    msVehicleId: dataForm.value.vehicle ? dataForm.value.vehicle.Id : null,
    trayekId: idTrayekParams.value,
    regNumber: dataForm.value.vehicle ? dataForm.value.vehicle.Nopol : null,
    trayekSubs: [] as any
  }

  // eslint-disable-next-line array-callback-return
  dataForm.value.pps.map((data: any) => {
    const obj = {
      id: data.Id,
      order: data.Order,
      arrivalTime: data.pp2.length === 5 ? `${data.pp2}:00` : data.pp2,
      departureTime: data.pp1.length === 5 ? `${data.pp1}:00` : data.pp1
    }
    payload.trayekSubs.push(obj)
  })

  console.log('payload', payload)
  try {
    const response = await apiUseCase.postOrPut(endpointTrayekDetail, idDetailParams.value, payload)
    if (!response.error) {
      // eslint-disable-next-line no-use-before-define
      hideDialogConfirmation()
      // eslint-disable-next-line no-use-before-define
      hideSidebar(0)
      $toast.add({
        severity: 'success',
        detail: response.message,
        group: 'bc',
        closable: false,
        life: 3000
      })
    } else {
      // eslint-disable-next-line no-use-before-define
      hideDialogConfirmation()
      // eslint-disable-next-line no-use-before-define
      hideSidebar(1)
    }
  } catch (error) {
    console.log('error', error)
  }
  store.dispatch('hideLoading')
}

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
}

const hideSidebar = (val: any = null) => {
  emit('hideDialog', val)
  store.dispatch('setTitleFormSidebar', null)
}

const mappingDetail = (data: any) => {
  initialValues.vehicle = {
    ...data.MsVehicle,
    label: data.MsVehicle?.Nopol,
    value: data.MsVehicle?.Id
  }

  for (let index = 0; index < Number(data.TrayekSubs.length ?? 0); index++) {
    // const element = array[index];
    const arrival = data.TrayekSubs[index]?.ArrivalTime ? moment(data.TrayekSubs[index].ArrivalTime, 'HH:mm') : null
    const departure = data.TrayekSubs[index]?.DepartureTime ? moment(data.TrayekSubs[index].DepartureTime, 'HH:mm') : null
    const objSubs = {
      ...data.TrayekSubs[index],
      // pp1: departure ? departure.toDate() : null,
      // pp2: arrival ? arrival.toDate() : null
      pp1: data.TrayekSubs[index]?.DepartureTime,
      pp2: data.TrayekSubs[index]?.ArrivalTime
    }
    initialValues.pps.push(objSubs)
    console.log('initial', initialValues)
  }
  isLoading.value = false
}

const getTrayekDetailData = () => {
  store.dispatch('showLoading')
  isLoading.value = true
  apiUseCase.get(`${endpointTrayekDetail}/${idDetailParams.value}`).then((response) => {
    if (!response.error) {
      const resTemp = response.result
      mappingDetail(resTemp)
    }
  })
  store.dispatch('hideLoading')
}

onMounted(() => {
  getTrayekDetailData()
  store.dispatch('setTitleFormSidebar', 'Edit Slot Trayek')
})

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Form), {
          onSubmit: onSubmit,
          "validation-schema": _unref(schema),
          "initial-values": initialValues,
          class: "form-container"
        }, {
          default: _withCtx(({ errors, setFieldValue, values, meta }) => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_unref(Field), { name: "vehicle" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(SelectFetch, _mergeProps(field, {
                      placeholder: 'Pilih Bus',
                      modelValue: field.value,
                      "input-id": "class-input",
                      endpoint: "/management/v1/MsVehicle",
                      searchCustom: [['activeOnly', '=', true], ['orderByHasTrayek', '=', false]],
                      selectable: (v) => v.Trayek === null,
                      fieldLabel: (v) => v.Nopol,
                      clearable: true,
                      searchFields: ['nopol']
                    }), null, 16, ["modelValue", "selectable", "fieldLabel"])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_5, _toDisplayString(errors.nopol), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(FieldArray), { name: "pps" }, {
                default: _withCtx(({ fields, push, remove }) => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (field, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: field.key
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(`PP ${idx + 1}`), 1),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_unref(Field), {
                              name: `pps[${idx}].pp1`
                            }, {
                              default: _withCtx(({ field, handleChange, handleBlur }) => [
                                _createElementVNode("div", {
                                  class: "text-xs font-normal",
                                  for: `pp1-${idx}`
                                }, "Jam Berangkat", 8, _hoisted_11),
                                _createVNode(_unref(InputText), _mergeProps({
                                  type: "time",
                                  class: "time-pp w-full mb-2",
                                  id: `pp1-${idx}`
                                }, field, {
                                  modelValue: field.value
                                }), null, 16, ["id", "modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["name"]),
                            _createElementVNode("div", _hoisted_12, _toDisplayString(errors[`pps[${idx}].pp1`]), 1)
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _createVNode(_unref(Field), {
                              name: `pps[${idx}].pp2`
                            }, {
                              default: _withCtx(({ field, handleChange, handleBlur }) => [
                                _createElementVNode("div", {
                                  class: "text-xs font-normal",
                                  for: `pp2-${idx}`
                                }, "Jam Kedatangan", 8, _hoisted_14),
                                _createVNode(_unref(InputText), _mergeProps({
                                  type: "time",
                                  class: "time-pp w-full mb-2",
                                  id: `pp2-${idx}`
                                }, field, {
                                  modelValue: field.value
                                }), null, 16, ["id", "modelValue"])
                              ]),
                              _: 2
                            }, 1032, ["name"]),
                            _createElementVNode("div", _hoisted_15, _toDisplayString(errors[`pps[${idx}].pp2`]), 1)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1024),
              (meta.touched)
                ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                    key: 0,
                    class: "invalid-feedback",
                    name: `pps`
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_unref(Button), {
                class: "btn-back mr-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (hideSidebar()))
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                class: "btn-primary mr-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_18
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"]),
        _createVNode(HjpCofirmModal, {
          show: attrModalConfirmation.show,
          imgContent: attrModalConfirmation.imgContent,
          title: attrModalConfirmation.title,
          subTitle: attrModalConfirmation.subTitle,
          btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
          onHideDialog: hideDialogConfirmation,
          onOnSubmit: onSubmitConfirmation
        }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle"])
      ]))
    : _createCommentVNode("", true)
}
}

})